import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { CommunicationProtocol } from 'icreate/common/models/communication-protocol';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CommunicationProtocolService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll() {
        return await lastValueFrom(
            this.http.get<CommunicationProtocol[]>(`${this.domain}/api/communication-protocol`, {
                headers: this.headers,
            })
        );
    }

    async create(protocol: CommunicationProtocol) {
        return await lastValueFrom(
            this.http.post<CommunicationProtocol>(`${this.domain}/api/communication-protocol`, protocol, {
                headers: this.headers,
            })
        );
    }

    async update(protocol: CommunicationProtocol) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/communication-protocol`, protocol, {
                headers: this.headers,
            })
        );
    }

    async deleteComm(protocol: CommunicationProtocol) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/communication-protocol`, { body: protocol }));
    }
}
